import React from 'react';
import PropTypes from 'prop-types';

class BlogSearchForm extends React.Component {

    state = {
        queryQuestion: ''
    }

    componentDidMount() {
        this.props.queryQuestion && this.setState({ queryQuestion: this.props.queryQuestion })
    }

    onChange = e => {
        this.setState({ [e.target.name]: e.target.value })
    };

    onSubmit = e => {
        e.preventDefault()
        const { queryQuestion } = this.state
        const { category } = this.props
        // NO QUERY NO CATEGORY
        if (!queryQuestion && !category) return window.location = `/blog`
        // JUST QUERY
        if (queryQuestion && queryQuestion.length > 0 && !category) return window.location = `/blog?question=${encodeURI(queryQuestion)}`
        // JUST CATEGORY
        if (!queryQuestion && category) return window.location = `/blog?category=${category}`
        // BOTH
        if (queryQuestion && category) return window.location = `/blog?category=${category}&question=${encodeURI(queryQuestion)}`
    }

    render() {
        return (
                <div className="input-group blog-search-form">
                    <input
                        type="text"
                        value={this.state.queryQuestion}
                        onChange={this.onChange}
                        name="queryQuestion"
                        placeholder="Search"
                        className="form-control"
                    />
                    <div className="input-group-addon" onClick={this.onSubmit}>
                        <span className="input-group-text"><i className="fa fa-search"></i></span>
                    </div>
                </div>
        )
    }
}

BlogSearchForm.propTypes = {
    queryQuestion: PropTypes.string,
    category: PropTypes.string,
}

export default BlogSearchForm;



// WEBPACK FOOTER //
// src/client/components/site/features/blogs/BlogSearchForm.js